import { Component, OnInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { CancellationRuleService } from './cancellation-rule.service';
import { buttonStatus } from '../../shared/constants/button-class';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import {
  ellipsisOptions,
  ellipsisHeaderOptions,
} from 'src/app/modules/crm/shared/constants/ellipsis-options';
import { KeyMap } from '../../shared/interface/key-map.interface';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationService } from 'primeng/api';
import { FormField } from '../../shared/form-field/form-field';
import { FormGroup } from '@angular/forms';
import { CoverageFormFieldService } from '../coverage-form-field.service';
import { FormFieldControlService } from '../../services/form-field-control.service';
import { modalEllipsisHeaderOptions } from '../coverage.constant';
import { FormCanDeactivate } from '../../shared/form-field/form-can-deactivate';
import { copy } from '../../shared/utilities/common-utilities';

@Component({
  standalone: false,
  selector: 'cv-cancellation-rule',
  templateUrl: 'cancellation-rule.template.html',
  providers: [CancellationRuleService, FormFieldControlService, CoverageFormFieldService],
})
export class CancellationRuleComponent extends FormCanDeactivate implements OnInit {
  dataList: any[];
  cols: any[];
  btnStatus: any = buttonStatus;
  selectedItem: any;
  ellipsisOptions: any[] = ellipsisOptions;
  ellipsisHeaderOptions: any[] = copy(ellipsisHeaderOptions);
  selectedEllipsisItem: any;
  clonedRowData: KeyMap = {};
  isEditing: boolean;
  editConstant: string;
  selectedRowIndex: number;
  formFields: FormField<string>[] = [];
  form: FormGroup;
  displayDialog: boolean;
  @Output() formValueChanged: EventEmitter<boolean> = new EventEmitter();
  dialogCols: any[];
  dialogDataList: any[];
  modalEllipsisHeaderOptions: any[] = modalEllipsisHeaderOptions;
  constructor(
    private cancellationRuleService: CancellationRuleService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private service: CoverageFormFieldService,
    private qcs: FormFieldControlService,
  ) {
    super();
  }

  ngOnInit() {
    this.editConstant = uuidv4();
    this.cancellationRuleService.getCancellationRules().subscribe((data) => {
      this.dataList = data;
    });
    this.service.getCancellationRuleFormFields().subscribe((data: FormField<string>[]) => {
      this.formFields = data;
      this.form = this.qcs.toFormGroup(this.formFields);
      this.form.valueChanges.subscribe((x) => {
        this.formValueChanged.emit(true);
      });
    });
    this.cols = [
      { field: 'ruleName', header: 'RULE NAME', type: 'text' },
      { field: 'productType', header: 'PRODUCT TYPE', type: 'text' },
      { field: 'saleFrom', header: 'SALE FROM', type: 'text' },
      { field: 'saleTo', header: 'SALE TO', type: 'text' },
      { field: 'defaultRule', header: 'DEFAULT RULE', type: 'checkbox' },
    ];
    this.dialogCols = [
      { field: 'state', header: 'STATE', type: 'text' },
      { field: 'ruleConfiguration', header: 'Rule Configuration', type: 'text' },
    ];
  }

  ellipsisClick(event, item, Popover: Popover, rowIndex) {
    this.selectedItem = item;
    this.selectedRowIndex = rowIndex;
    toggleEllipsisPopover(event, Popover);
  }

  ellipsisOptionClick(event) {
    // ellipsis functionality goes here
  }

  onRowEdit() {
    this.isEditing = true;
    document.getElementById(this.editConstant + this.selectedItem.id).click();
  }

  onRowEditInit(rowData: any) {
    this.clonedRowData[rowData.id] = { ...rowData };
  }
  onRowEditSave(rowData: any) {
    delete this.clonedRowData[rowData.id];
    this.isEditing = false;
  }

  onRowEditCancel(rowData: any, index: number) {
    if (rowData[`isNew`]) {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to discard, these changes?',
        accept: () => {
          this.dataList[index] = this.clonedRowData[rowData.id];
          delete this.clonedRowData[rowData.id];
          this.isEditing = false;
          this.dataList.splice(this.selectedRowIndex, 1);
        },
      });
    } else {
      this.dataList[index] = this.clonedRowData[rowData.id];
      delete this.clonedRowData[rowData.id];
      this.isEditing = false;
    }
  }

  onRowDelete(event, Popover: Popover) {
    Popover.hide();
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this row?',
      accept: () => {
        this.dataList.splice(this.selectedRowIndex, 1);
      },
    });
  }

  onClickAdd(event) {
    this.cancellationRuleService.getState().subscribe((data) => {
      this.dialogDataList = data;
    });
    this.displayDialog = true;
  }

  addNewRowItem() {
    const rowItem = this.form.getRawValue();
    rowItem.id = this.dataList.length + 1;
    rowItem.lossCodeType = rowItem.lossCodeType ? rowItem.lossCodeType.key : '';
    this.dataList.push(rowItem);
    this.displayDialog = false;
    this.formValueChanged.emit(this.form.dirty);
  }
}
